import React from 'react';
import '../styles/ContactPage.css';
import { Link } from 'react-router-dom';
import Cal from "@calcom/embed-react";

const ContactPage: React.FC = () => {

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-page-container p-8 md:p-12">
      {/* Hero Section with Particles Background */}
      <div className="contact-page-header">
        <div className="contact-header-content">
          <div className="contact-header-tag">Get in Touch</div>
          <h2 className="animate-fade-in">
            Let's Build Something Amazing Together
          </h2>
          <p className="contact-header-subtitle">
            Have a project in mind? We'd love to discuss how we can help bring your vision to life.
          </p>
        </div>
        <div className="particles-background"></div>
      </div>

      <div className="contact-page-content">
        <div className="contact-layout">
          {/* Calendar Area - Now Full Width at Top */}
          <div className="contact-interaction-area contact-full-width">
            <div className="contact-calendar-header">

              <div className="bottlenecks-header">
                <h2 className="bottlenecks-title">Book a 30-Minute <span>Consultation</span></h2>
                <p className="bottlenecks-subtitle">
                  Schedule a call with our team to discuss your project requirements and how we can help bring your vision to life.
                </p>
              </div>
            </div>

            {/* Cal.com React Component */}
            <div className="cal-embed-container">
              <Cal
                calLink="himanshu-bhutani-pglmki/30min"
                style={{ width: "100%", height: "100%", overflow: "hidden" }}
                config={{
                  hideEventTypeDetails: "false",
                  hideBranding: "true"
                }}
              />
            </div>
          </div>

          {/* Contact Info Card - Now Below Calendar */}
          <div className="contact-info-card contact-full-width">
            <div className="contact-message-section">
              <div className="message-highlight">
                <h2 className="message-title">We Would Love to Hear<br />from You</h2>
              </div>
              <div className="message-content">
                <p>Thank you for your interest in betaque and our mission to help businesses thrive. We value your thoughts, questions, and feedback. Please don't hesitate to reach out to us. Our dedicated team is here to assist you.</p>
                
                <div className="social-circles">
                  <a href="#" className="social-circle" aria-label="Facebook">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                  </a>
                  <a href="#" className="social-circle" aria-label="Twitter">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                    </svg>
                  </a>
                  <a href="#" className="social-circle" aria-label="LinkedIn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                      <rect x="2" y="9" width="4" height="12"></rect>
                      <circle cx="4" cy="4" r="2"></circle>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            
            <div className="contact-simple-boxes">
              <div className="contact-simple-box">
                <div className="contact-simple-content">
                  <h4>Address</h4>
                  <p>6A, TI Next, Indore, Madhya Pradesh 452001</p>
                </div>
                <div className="contact-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M7 17l9.2-9.2M17 17V7H7"></path>
                  </svg>
                </div>
              </div>
              
              <div className="contact-simple-box">
                <div className="contact-simple-content">
                  <h4>You Can Email Here</h4>
                  <p>info@betaque.com</p>
                </div>
                <div className="contact-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M7 17l9.2-9.2M17 17V7H7"></path>
                  </svg>
                </div>
              </div>
              
              <div className="contact-simple-box">
                <div className="contact-simple-content">
                  <h4>Call us on</h4>
                  <p>+91 9406850681</p>
                </div>
                <div className="contact-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M7 17l9.2-9.2M17 17V7H7"></path>
                  </svg>
                </div>
              </div>
              
              <div className="contact-simple-box">
                <div className="contact-simple-content">
                  <h4>Working Hours</h4>
                  <p>10:00 am - 6:00 pm</p>
                </div>
                <div className="contact-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M7 17l9.2-9.2M17 17V7H7"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 